import { ascending } from 'd3'

export function generateOptions (cellParams) {
  const { entities } = cellParams.context.browserAppAccount.data

  let selectOptions = entities.map(function (entity) {
    return {
      value: entity.id,
      label: entity.name
    }
  })

  // Filter out the entity of the column itself
  selectOptions = selectOptions.filter(function (option) {
    return option.value !== cellParams.colDef.context.accountingOrganisation.id
  })
  selectOptions.sort(function (a, b) {
    return ascending(a.label, b.label)
  })

  // Add the 'none' option
  selectOptions.unshift({
    value: 'none',
    label: '- Not intercompany account'
  })

  return selectOptions
}
